/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'mdm-upload': {
    width: 15,
    height: 12,
    viewBox: '0 0 15 12',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M10.442 3.844c.231.23.472.32.743.044.241-.244.166-.546-.037-.75L8.283.274c-.415-.416-1.027-.315-1.376.034L4.078 3.137c-.24.24-.268.525-.027.766.24.24.495.18.734-.06l2.122-2.12c.062-.064.131-.116.205-.159v5.808c0 .35.269.624.506.622.266-.003.493-.265.493-.62V1.561a1 1 0 0 1 .21.161l2.121 2.122zm4.17 2.656c0-.419-.18-.605-.501-.605-.322 0-.5.183-.5.605v4h-12v-4c0-.471-.174-.605-.496-.605-.361 0-.504.142-.504.605v4c0 .72.294 1 1 1h12c.533 0 1-.361 1-1v-4z" _fill="#006265"/>'
  }
})
